<template>
  <div class="container-flex margin-header">
    <nav class="navbar">
      <div class="container-fluid">
        <div class="col-lg-4 col-sm-12 col-12 justify-content-center">
          <transition name="logo">
            <router-link class="justify-content-center center-logo" draggable="false" :to="{path:'/'}">
              <img :class="logoClass" src="./assets/pilous-logo.png" alt="Pilous logo" class="big-logo" draggable="false" @click="redirectHome">
            </router-link>
          </transition>
        </div>
        <div class="col-lg-6 col-md-9 col-8 ">
          <div class="container">
            <nav class="navbar navbar-expand-sm">
              <div class="container-fluid justify-content-center">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <router-link class="nav-link" v-if="!isLoggedIn" draggable="false" to="/login"><h5>{{ login }}</h5></router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" v-if="isLoggedIn" draggable="false" to="/dashboard"><h5>{{ dashboard }}</h5></router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" draggable="false" to="/contact"><h5>{{ contact }}</h5></router-link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-4">
          <select class="form-select-sm" @change="changeLanguage($event.target.value)">
            <option v-for="language in this.$store.state.languageData.availableLanguages"
            :key="language.long_code"
            :value="language.long_code"
            :selected="language.long_code == this.$store.state.languageData.languageCode"
            >{{ language.name }}
            </option>
          </select>
        </div>
      </div>
    </nav>
  </div>
  <div>
    <div class="row justify-content-center">
      <div v-if="isLoggedIn && loginInitiationDone" class="col-lg-3 col-12 justify-content-center mininav">
        <router-link class="nav-link" draggable="false" to="/createorder"><p class="col-lg-12 col- text-center">{{ mininav_new_order }}</p></router-link>
        <router-link class="nav-link" draggable="false" to="/createorder"><p class="col-lg-12 col- text-center">{{ mininav_new_delivery_note }}</p></router-link>
      </div>
      <div class="row justify-content-center" v-if="!loginInitiationDone">
        <div class="col-12" style="text-align: center;">
          <span class="spinner-border spinner-border-sm spin"></span>
        </div>
      </div>
      <div class="col-lg-9 col-12 content" v-if="loginInitiationDone">
        <router-view></router-view>
      </div>
    </div>
  </div>
  
</template>

<script>


export default {

  name: 'PoolingPortal',
  data(){
    return{
      loginInitiationDone : false
    }
  },
  async created(){
    try{
      await Promise.all([
        this.$store.dispatch('initCookies'),
        this.$store.dispatch('getLanguageFromCookies'),
        this.$store.dispatch('getAvailableLanguages'),
        this.$store.dispatch('getLanguageData')
      ]);
      setTimeout(()=>{
        this.loginInitiationDone = true;
      }, 250)
    }catch (error) {
      this.$store.dispatch('setLanguageError', error.message);
    }
  },
  methods:{
    changeLanguage(languageCode){
      this.$store.dispatch('setLanguageCode', languageCode);
    }
  },
  computed:{
    logoBig(){
      return this.$route.path === '/login';
    },
    logoClass(){
      return this.logoBig ? 'big-logo' : 'small-logo';
    },
    login(){
      return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.login_nav : 'Login';
    },
    dashboard(){
      return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dashboard_nav : 'Dashboard';
    },
    mininav_new_order(){
      return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.mininav_new_order : 'Create new order';
    },
    mininav_new_delivery_note(){
      return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.mininav_new_delivery_note : 'Create new delivery note';
    },
    contact(){
      return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.contact_nav : 'Contact';
    },
    isLoggedIn(){
      return this.$store.state.sessionData.loggedIn;
    }
  }
}
</script>

<style scoped>
#PoolingPortal {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}

.mininav{
  padding-top: 20px;
}

.spin{
  width: 6rem;
  height: 6rem;
}

.center-logo{
  margin: auto;
}
.navbar{
  background-color: #ffffffc4;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-drag: none;
  -webkit-user-drag: none;
  cursor: default;
}

.big-logo {
    height: 100px;
    width: auto;
    margin: auto;
    transition: all 1s;
}

.small-logo {
    height: 60px;
    width: auto;
    margin: auto;
    transition: all 1s;
}

.margin-header{
  margin-bottom: 20px;
  box-shadow: 0px 4px 10px #3838382c;
}

</style>
